import React from "react";
import Footer from "../components/footer";

const RefundPolicyPage = () => (
  <div className="min-h-screen bg-gradient-to-br from-black via-gray-900 to-black text-gray-200 px-6 py-12">
        <div className="max-w-5xl mx-auto">
            <h1 className="text-3xl font-bold mb-6 text-green-400">Refund Policy</h1>
            <p className="mb-4">We aim to provide a fair and transparent refund policy. Please read the conditions below regarding cancellations and refunds.</p>
            <h2 className="text-xl font-semibold text-white mt-6 mb-2">Cancellations</h2>
            <p className="mb-4">Orders can be canceled within 24 hours of purchase if the service or product hasn't been initiated or delivered.</p>
            <h2 className="text-xl font-semibold text-white mt-6 mb-2">Eligibility for Refunds</h2>
            <p className="mb-4">Refunds are only processed for faulty or incomplete service deliveries, subject to verification by our support team.</p>
            <h2 className="text-xl font-semibold text-white mt-6 mb-2">Refund Process</h2>
            <p className="mb-4">Approved refunds will be processed to the original payment method within 7–10 business days.</p>
            <p className="mt-8 text-sm text-gray-400">Last updated: June 16, 2025</p>
        </div>
    </div>
);

export default RefundPolicyPage;